import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RemitaRespondse, RemittaModel} from "../../../models/remiteResponse.model";
import {environment} from "../../../../environments/environment";
import {ModalDismissReasons, NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {ScriptService} from "../../../Services/script-service.service";
import {RemitaPaymentService} from "../../../Services/RemitaPaymentService";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {PaymentSuccessComponent} from "../../payment/payment-success/payment-success.component";
import {RemitaSuccessModalComponent} from "../../payment/remita-success-modal/remita-success-modal.component";
import {en} from "@fullcalendar/core/internal-common";
import {ToastService} from "../../../Services/ToastService";

declare const RmPaymentEngine: any;
@Component({
  selector: 'app-public-payment-modal',
  templateUrl: './public-payment-modal.component.html',
  styleUrls: ['./public-payment-modal.component.css']
})
export class PublicPaymentModalComponent implements OnInit{

  @Output() onConfirmClicked = new EventEmitter();
  @Input() details: any;
  @Input() paymentCategory: string | null = null;
  // paymentInfo: any;
  isLoading = false;
  remita: RemitaRespondse | any;
  interswitch: any;
  processingPayment: Boolean = false;
  message: String = "";
  closeResult:string="";
  // remitaInlineKey= environment.remitaInLineKey;
  paymentResponse: any = {};
  paymentType?: string;
  public paymentTransactionHistory: any;
  validatePayment: Boolean = true;

  merchantCode = environment.merchantCode;
  payItemId = environment.payItemId;
  interSwitchMode = environment.interSwitchMode;
  modalOptions:NgbModalOptions;

  getPaymentOption?: string;
  errorMessage: string | null = null;
  isLoadingInterswitch: boolean = true;
  generating: boolean;

  constructor(
      public modalRef: BsModalRef,
      private scriptService: ScriptService,
      private remitaPaymentService: RemitaPaymentService,
      private spinner:ToastService,
      private bsModalService: BsModalService,) {
  }

  generateRRR() {
    this.spinner.spin();
    this.isLoading = true;
    const details = {
      amount:Math.ceil(Number(this.details.totalAmount)),
      // serviceTypeId:this.mdaRecord?.id,
      payerName:this.details.customerId,
      payerEmail:this.details.customerId,
      payerPhone:this.details.customerId,
      // revenueId:this.mdaRecord?.id
    }
    this.remitaPaymentService.generateRemitaRRR(details).subscribe(value => {
      this.spinner.hide();
      this.close();
      this.remita = value;
      this.loadRemitaIframe(this.remita.rrr, this.remita)
      this.isLoading = false;
    }, error => {
      this.spinner.hide();
      this.close();
      console.log(error);
    })
  }

  ngOnInit(): void {
  }

  startRemita(){
    this.generating=true;
    this.scriptService.loadScript('remita_inline').then(r => {
      this.generateRRR();
    });
  }

  interswitchStart(){
    this.generating=true;
    this.startInterswitch();
  }
  private dismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  loadRemitaIframe(rrr: any, remita: any): void {
    const paymentEngine = RmPaymentEngine.init({
      key: environment.remitaInLineKey,
      processRrr: true,
      transactionId: remita.orderId,
      extendedData: {
        autofill: true,
        customFields: [
          {
            name: 'rrr',
            value: remita.rrr
          }
        ]
      },
      onSuccess: (response: any) => {
        const order = {
            orderId: remita.orderId,
            rrr: remita.rrr,
            paymentReference: response.paymentReference,
            transactionId: response.transactionId,
            amount: remita.amount,
            responseurl: remita.responseurl
        }
        this.paymentResponse = response;

        this.processingPayment = true;
        this.message = "Processing payment... Please wait";

        // document.getElementById('remitaSucess')?.click()
        this.remitaPaymentService.acknowledgementRRR(order).subscribe(
            response => {
                this.message = "Success!";
                this.remitaPaymentService.validatePayment(response.id).subscribe(response => {
                  this.paymentSuccess(response);
                }, error => { console.log(response); });

            },
            error => {
              this.message = "Not successful!";
              setTimeout(() => {
                this.close();
              }, 3000);
              this.processingPayment = false;
              console.info(`Remita Acknowledgement on RRR error: ${error}`);
            });


      },
      onError: (response: any) => {
        this.message = "Not successful!";
        setTimeout(() => {
          document.getElementById('closeRemitaPop')?.click()
        }, 3000);
        this.processingPayment = false;
        console.log("error: " + JSON.stringify(response));
        // this.openDialog(remita, invoice, false, index);
      },
      onClose: () => {
        console.log('closed');
      }
    });

    
    paymentEngine.showPaymentWidget();
  }


  checkout() {
    var paymentRequest = {
      merchant_code: this.merchantCode,
      pay_item_id: this.payItemId,
      txn_ref: this.interswitch.orderId,
      cust_id: this.details.customerId,
      amount:Math.ceil((this?.details?.totalAmount*100 + Number.EPSILON) * 100)/100,
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: (response: any) => {this.paymentCallback(response)},
      mode: this.interSwitchMode,
      pay_item_name: this.details.feeDescription,
      // cust_name:this.details.payerName,
      cust_name:this.details.fullName,
      cust_email: this.details.email,
      cust_mobile_no: this.details.phoneNumber
      // split_accounts :this.interSwitchMode == "LIVE" && (this.interswitch?.splitAccounts?.isEmpty || this.interswitch?.splitAccounts == null) ? "" : JSON.stringify(this.interswitch?.splitAccounts)
    };
    if (this.interSwitchMode === "LIVE" && this.interswitch?.splitAccounts && Object.keys(this.interswitch.splitAccounts).length > 0) {
      paymentRequest['split_accounts'] = JSON.stringify(this.interswitch.splitAccounts);
    }
    (window as any).webpayCheckout(paymentRequest);
  }
  
  paymentCallback(response:any){
      console.log("Payment response {}"+ response);
    if(response != null && parseFloat(response.amount) >0 ){
      console.log(response)
      sessionStorage.setItem('interResponse', JSON.stringify(response));
      let pathName = "/payment/return-back/" + response.txnref + "/" + response.amount;

      setTimeout(()=>{
        window.open(pathName, "_self")
      }, 50);
    }
  }

  startInterswitch() {
    this.spinner.spin()

    const request = { ...this?.details };

    if (this.paymentCategory === "PENALTY") {
      request["paymentCategory"] = "PENALTY";
    }
    this.remitaPaymentService.startInterswitchInline(request).subscribe(
        response => {
          this.spinner.hide();
          this.close();
          this.isLoadingInterswitch = false;
          this.interswitch = response;
          this.scriptService.loadScript('switch_inline').then(r => {
            this.checkout();
          });
        },
        error => {
          this.isLoadingInterswitch = false;
          console.info(`Remita Generate RRR error: ${error}`);
        });
  }

  paymentSuccess(response:any){
    this.close();
    let bsModalRef = this.bsModalService.show(RemitaSuccessModalComponent, {
      initialState : {
        details:response
      },
      class: 'modal-md modal-dialog-centered',
      ignoreBackdropClick: true,
    });
    bsModalRef?.content?.onConfirmClicked.subscribe(v => {
      bsModalRef.hide();
    });
  }
  closeModal() {
    this.bsModalService.hide();
  }
  close() {
    this.onConfirmClicked.emit();
    this.modalRef.hide();
  }
}
